"use client"

import Link from "next/link"
import { useParams } from "next/navigation"
import { useState } from "react"
import { useTranslations } from "next-intl"
import { Info, X } from "lucide-react"
import { DemoAppSidebar } from "@/components/demo-sidebar"
import { DashboardShell } from "@/components/dashboard/dashboard-shell"

function DemoBanner() {
  const [show, setShow] = useState(true)
  const t = useTranslations("demoDashboard.banner")
  if (!show) return null

  return (
    <div className="flex items-center justify-between gap-4 border-b border-amber-500/20 bg-amber-500/5 px-4 py-2.5">
      <div className="flex items-center gap-2 text-sm">
        <Info className="h-4 w-4 text-amber-400 shrink-0" />
        <span className="text-amber-200/80">
          <strong className="text-amber-300">{t("label")}</strong> — {t("body")}{" "}
          <Link href="/monitoring/demo-dashboard/try-recording" className="underline hover:text-amber-300">
            {t("tryDemo")}
          </Link>
        </span>
      </div>
      <button onClick={() => setShow(false)} className="text-amber-400/50 hover:text-amber-400">
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}

export default function DemoDashboardLayout({ children }: { children: React.ReactNode }) {
  const params = useParams()
  const locale = (params.locale as string) || "en"

  return (
    <DashboardShell sidebar={<DemoAppSidebar locale={locale} />}>
      <DemoBanner />
      {children}
    </DashboardShell>
  )
}
